module.exports = __webpack_public_path__ + "static/img/user_img.4687e231.png";